export default "__VITE_ASSET__CVgwCEkT__"